/**
 * v2 application shell — Navbar + main outlet.
 *
 * Mounted under ``/v2/*`` during the build phase. At ship time the
 * route map flips: this shell takes ``/`` and v1's Layout moves to
 * ``/v1/*``. SessionProvider + RequireAuth + the global SSE stream
 * stay one layer above this — they're shared between v1 and v2.
 */
import { Outlet } from "react-router-dom";

import { Navbar } from "./Navbar";

export function AppShell() {
  return (
    <div
      className={[
        "flex min-h-screen flex-col",
        // Dark default matches v1's posture. The ``dark:`` variant
        // class is added/removed by ThemeProvider on <html>.
        "bg-slate-950 text-slate-100",
        "dark:bg-slate-950 dark:text-slate-100",
      ].join(" ")}
    >
      <Navbar />
      <main className="mx-auto w-full max-w-7xl flex-1 px-6 py-6">
        <Outlet />
      </main>
    </div>
  );
}
